import { DateTime } from 'luxon'

export function getFormattedTimestamp(timestamp: string | number): string {
  const dateTime =
    typeof timestamp === 'string'
      ? DateTime.fromISO(timestamp)
      : DateTime.fromMillis(timestamp)
  return dateTime.toFormat('kkkk/LL/dd TT.SSS ZZZZ')
}
